import { openingPreimage } from '@tctp/engine/browser';
import type { CardOpening } from '@tctp/protocol';

export interface OpeningCheck {
  position: number;
  ok: boolean;
  expected: string;
  computed: string;
  preimage: string;
}

export async function sha256Hex(text: string, subtle: SubtleCrypto = globalThis.crypto.subtle): Promise<string> {
  const digest = await subtle.digest('SHA-256', new TextEncoder().encode(text));
  return [...new Uint8Array(digest)].map(b => b.toString(16).padStart(2, '0')).join('');
}

/** Recompute one opening's commitment hash the way the server did and compare. */
export async function checkOpening(handId: string, commitment: string[], o: CardOpening, subtle?: SubtleCrypto): Promise<OpeningCheck> {
  const preimage = openingPreimage(handId, o.position, o.card, o.saltHex);
  const computed = await sha256Hex(preimage, subtle);
  const expected = commitment[o.position] ?? '';
  const ok = commitment.length === 52 && expected !== '' && computed === expected;
  return { position: o.position, ok, expected, computed, preimage };
}

export function verifyOpenings(handId: string, commitment: string[], openings: CardOpening[], subtle?: SubtleCrypto): Promise<OpeningCheck[]> {
  return Promise.all(openings.map(o => checkOpening(handId, commitment, o, subtle)));
}
